import { useEffect, useMemo, useState } from 'react'
import { watchGame, saveSettlement, reopenGame } from './ggGamesData.js'
import { getPlayable } from './ggGameRegistry.js'
import { getGameUI } from './ggGameUI.jsx'
import GScatsResults from './GScatsResults.jsx'
import GSkinsResults from './GSkinsResults.jsx'
import GDotsResults from './GDotsResults.jsx'

// Shared results view (frame). Runs the game's engine on the saved scores and
// renders the game's ResultsView. Finalize snapshots the settlement to
// ggGames/{id} and marks the game final (re-openable).
export default function GGameResults({ gameId, onExit, onBackToScorecard }) {
  const [game, setGame] = useState(null)
  useEffect(() => watchGame(gameId, setGame), [gameId])

  const meta = game?.meta || {}
  const players = game?.players || []
  const reg = getPlayable(meta.gameId)
  const ui = getGameUI(meta.gameId)
  const result = useMemo(() => {
    if (!reg || !game) return null
    try { return reg.settle(players, game.scores || {}, meta.options || {}, { strokeIndex: meta.course?.strokeIndex, pars: meta.course?.pars, handicapsOn: meta.handicapsOn, teams: meta.teams, ...game, wolf: game.wolf || {}, wolfBet: game.wolfBet || {} }) } catch { return null }
  }, [reg, game, players, meta])

  if (!game) return <div className="card">Loading…</div>
  const final = meta.status === 'final'

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="font-bold text-lg">{meta.name} — Results</div>
          <div className="text-xs text-gray-500">{reg?.label} · {meta.course?.name} · {meta.handicapsOn ? `Net ${meta.allowance}%` : 'Gross'}{final ? ' · FINAL' : ' · in progress'}</div>
        </div>
        <button className="btn-ghost text-xs" onClick={onExit}>Games</button>
      </div>

      {ui.ResultsView ? <ui.ResultsView game={game} result={result} /> : <p className="text-gray-500 text-sm">No results view for this game.</p>}

      {/* Scats + Skins + Dots add-ons settle alongside the main game */}
      <GScatsResults game={game} />
      <GSkinsResults game={game} />
      <GDotsResults game={game} />

      <div className="flex items-center gap-2 pt-3">
        {onBackToScorecard && <button className="btn-ghost text-xs" onClick={onBackToScorecard}>← Back to scorecard</button>}
        {!final
          ? <button className="btn-primary" style={{ backgroundColor: '#1B4D2E' }} onClick={() => saveSettlement(gameId, result || {})}>Finalize &amp; Save</button>
          : <button className="btn-ghost text-xs" onClick={() => reopenGame(gameId)}>Re-open game</button>}
      </div>
    </div>
  )
}
